import React from "react";
import { findWrapperNode } from "../../../core/helpers";
import { EditorPopup } from "../../popup";
import { EditorCodeMenu } from "./EditorCodeMenu";
export const EditorCodePluginView = ({ view }) => {
    const target = findWrapperNode(view, view.state.schema.nodes.code_block);
    if (!target) {
        return null;
    }
    const handleLanguageChange = (language) => {
        const { node, pos } = target;
        const state = view.state;
        const attrs = {
            ...node.attrs,
            language: language.name,
        };
        const tr = state.tr.setNodeMarkup(pos, null, attrs);
        view.dispatch(tr);
        view.focus();
    };
    const handleLineWrappingChange = (lineWrapping) => {
        const { node, pos } = target;
        const state = view.state;
        const attrs = {
            ...node.attrs,
            lineWrapping,
        };
        const tr = state.tr.setNodeMarkup(pos, null, attrs);
        view.dispatch(tr);
        view.focus();
    };
    const handleRemove = () => {
        const { node, pos } = target;
        const state = view.state;
        const tr = state.tr.deleteRange(pos, pos + node.nodeSize);
        view.dispatch(tr);
        view.focus();
    };
    const attrs = target.node.attrs;
    return (React.createElement(EditorPopup, { view: view, referenceElement: view.nodeDOM(target.pos), placement: "bottom", visibleWhenEditorUnfocused: true },
        React.createElement(EditorCodeMenu, { languageName: attrs.language, lineWrapping: attrs.lineWrapping, onLanguageChange: handleLanguageChange, onLineWrappingChange: handleLineWrappingChange, onRemove: handleRemove })));
};
